import axios from 'utils/axios';

export const userLoginRequest = async ({ email, password, hasCaptcha = false, isRefresh = false }) => {
    try {
        const response = await axios.post(
            'auth/login',
            {
                email,
                password,
                isRefresh,
                hasCaptcha
            },
            {
                withCredentials: true
            }
        );
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const userValidateInitLogin = async (token) => {
    try {
        const response = await axios.post(
            'auth/verify-initial-login',
            {
                token
            },
            {
                withCredentials: true
            }
        );
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const requestLoginOtp = async (type) => {
    try {
        const response = await axios.post(
            'auth/otp/generate',
            { type },
            {
                withCredentials: true
            }
        );
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const verifyLoginOtp = async (code, method, hasCaptcha = false) => {
    try {
        const response = await axios.post('auth/otp/validate', {
            code,
            method,
            hasCaptcha
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const verifySession = async () => {
    try {
        const response = await axios.get('/auth/me', {
            withCredentials: true
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const dashLogout = async () => {
    try {
        const response = await axios.get('auth/logout', {}, { withCredentials: true });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const resendOtp = async (id) => {
    try {
        const response = await axios.post('auth/otp/resend', { id }, { withCredentials: false });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const requestResetPassword = async (email, hasCaptcha = false) => {
    try {
        const response = await axios.post('auth/reset-password', { email, hasCaptcha }, { withCredentials: false });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const validateResetPasswordToken = async (token) => {
    try {
        const response = await axios.get('auth/reset-password/validate-token', { params: { token } }, { withCredentials: false });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

export const changePassword = async (token, password) => {
    try {
        const response = await axios.post('auth/password', { token, password }, { withCredentials: false });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};

// set logged in user password
export const setPassword = async (password) => {
    try {
        const response = await axios.post('auth/set-password', { password }, { withCredentials: true });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
};
